module.exports = __webpack_public_path__ + "static/media/avatar1.30ff085b.png";